<template>
  <div class="content_wrapper tw-px-[25px] tw-pb-[25px]">
    <TableActionSwitchTab
      :tabs="tabs"
      :default-tab="0"
      @update:tab="activeTab = $event"
    />

    <component
      :is="tabs.filter((item) => item.id === activeTab)[0].component"
      class="tw-h-[18px] tw-w-[18px]"
      :data="detailData"
      :id-item-expand="idItemExpand"
      :is-action-table="isActionTable"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import TableActionSwitchTab from "./tableActionSwitchTab.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import { idTabActionTableRecommendation } from "@/utils/constants";
import overviewDetailActionTab from "./overviewDetailActionTab.vue";
import StepToSolveDetailActionTab from "./stepToSolveDetailActionTab.vue";

defineProps({
  detailData: {
    type: Object as () => any,
    required: false,
    default: null,
  },
  idItemExpand: {
    type: [String, Number],
    required: false,
    default: null,
  },
  isActionTable: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const activeTab = ref("1");

// add tab component to feild component
const tabs: ISwitchTabs[] = [
  {
    title: getComponentUiText(
      "app-assess-recommendations-action-table-label-tab-overview-1",
    ),
    id: idTabActionTableRecommendation.overview,
    component: overviewDetailActionTab,
  },
  {
    title: getComponentUiText(
      "app-assess-recommendations-action-table-label-tab-action-plan-1",
    ),
    id: idTabActionTableRecommendation.stepsToSolve,
    component: StepToSolveDetailActionTab,
  },
  // {
  //   title: getComponentUiText(
  //     "app-assess-recommendations-action-table-label-tab-makeplan-1",
  //   ),
  //   id: idTabActionTableRecommendation.makePlan,
  //   component: MakePlanDetailTab,
  // },
];
</script>
